// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-ehR1FZ","overlay":"overlay-zTN2nw"};